// Copyright (c) 2019 Deere & Company

import './index.scss';
import React, {Component, PropTypes} from 'react';
import {translate} from '../../../../shared/services/translation-service';

class ListViewShowMore extends Component {

    constructor(props) {

        super(props);
        this.state = {
            count: 1
        };

    }

    componentWillReceiveProps(newProps) {

        if (this.props.totalItems !== newProps.totalItems) {

            this.setState({
                count: 1
            });

        }

    }

    render() {

        return (
            <div>
                {this.props.children}
                {(this.props.totalPages !== this.state.count) &&
                    <footer className='show-more-footer'>
                        <button
                            className='button-primary'
                            onClick={() => {

                                this.setState(prevState => ({count: prevState.count + 1}));
                                this.props.handleMore(this.state.count);

                            }
                            }
                        >
                            {translate('SHOW_MORE')}
                        </button>
                    </footer>
                }
            </div>
        );

    }
}

ListViewShowMore.displayName = 'ListViewShowMore';
ListViewShowMore.propTypes = {
    children: PropTypes.node,
    handleMore: PropTypes.func,
    totalItems: PropTypes.number.isRequired,
    totalPages: PropTypes.number
};

export default ListViewShowMore;




// WEBPACK FOOTER //
// ./src/product/dealer-recommendations/components/list-view-show-more/index.js